module.exports = __webpack_public_path__ + "img/DW365-028.acd4b257.jpg";